module.exports = "/_next/static/images/error-401-e697f05b0e508b7829406e5d19a05c60.svg";